import { cn } from "@/lib/utils";

/**
 * Original logo mark for Velasco Lock and Safe.
 * Concept: a combination-safe dial (outer ring + tick marks) enclosing a
 * classic keyhole whose stem sharpens into a geometric "V".
 * Uses `currentColor` so it adapts to light or dark backgrounds.
 */
export const LogoMark = ({ className }) => {
  const ticks = Array.from({ length: 12 });
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* dial tick marks */}
      <g>
        {ticks.map((_, i) => (
          <line
            key={i}
            x1="24"
            y1="3.5"
            x2="24"
            y2={i % 3 === 0 ? "7.5" : "6"}
            stroke="currentColor"
            strokeWidth={i % 3 === 0 ? 1.6 : 1}
            strokeOpacity={i % 3 === 0 ? 0.95 : 0.45}
            strokeLinecap="round"
            transform={`rotate(${i * 30} 24 24)`}
          />
        ))}
      </g>
      {/* dial ring */}
      <circle cx="24" cy="24" r="16.5" stroke="currentColor" strokeWidth="2" />
      {/* keyhole head */}
      <circle cx="24" cy="20" r="4.1" fill="currentColor" />
      {/* keyhole stem sharpened into a V */}
      <path
        d="M20.3 25 L24 33.6 L27.7 25"
        stroke="currentColor"
        strokeWidth="2.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const VelascoLogo = ({ className, compact = false, wordColor = "text-white" }) => (
  <span className={cn("flex items-center gap-3", className)}>
    <img
      src="/media/velasco-logo.png"
      alt="Velasco Lock and Safe logo"
      className="h-11 w-11 shrink-0 object-contain"
    />
    {!compact && (
      <span className="leading-none">
        <span className={cn("block font-heading text-lg font-black tracking-tight", wordColor)}>
          VELASCO
        </span>
        <span className="block font-heading text-[10px] font-bold uppercase tracking-[0.28em] text-steel">
          Lock &amp; Safe
        </span>
      </span>
    )}
  </span>
);
